import Client from './HTTPClient';

const categoryExtensionsAPI = {
  list (request) {
    return Client.post('/api/categories-extensions/', request);
  }
};

export default categoryExtensionsAPI;
